export default __webpack_public_path__ + "static/media/pig.e055847d.svg";